import type { ReactNode } from 'react';
import type { CrmAccountContractorSummary } from '@ip/shared-types';

interface Props {
  contractor: CrmAccountContractorSummary;
  /** Znacznik przy nazwie (np. skąd wziął się kandydat). */
  badge?: ReactNode;
}

/**
 * Jak kontrahent przedstawia się na karcie klienta: nazwa i pod nią to, co
 * odróżnia go od podobnie nazwanego (NIP, miasto). Jeden kształt dla panelu
 * „Kontrahent" i dla listy kandydatów, żeby wybór i wynik wyboru wyglądały
 * tak samo.
 */
export function ContractorSummaryLine({ contractor, badge }: Props) {
  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-medium">{contractor.name ?? '—'}</span>
        {badge}
      </div>
      <div className="text-muted-foreground text-xs">
        {[contractor.nip, contractor.city].filter(Boolean).join(' · ') || '—'}
      </div>
    </>
  );
}
